(function Module() {
	'use strict';

	var impParnellCommon = require('../static/js/imported-parnell-common-modules');

	const log = require('parnell-log');
	var _ = require('lodash');
	var moment = require('moment');
	var mySynchModules =  require('./config');
	const mySynchEnumeration = require('parnell-mysynch-enum');
	const async = require('../static/lib/async/lib/async');

module.exports = {impParnellCommon,log,_,moment,mySynchModules,mySynchEnumeration,async};

})();